import React, { FC } from 'react';
import { RefundPricesFragment } from '@websky/graphql';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import ElementsPriceDetails from '../ElementsPriceDetails/ElementsPriceDetails';
import { useTheme } from '../../../../../../../theme';
import PriceItem from '../PriceItem/PriceItem';
import TotalRefund from '../TotalRefund/TotalRefund';
import { Props as PriceItemProps } from '../PriceItem/PriceItem';

interface Props {
	prices: RefundPricesFragment;
	additionalPrices?: PriceItemProps[];
	className?: string;
}

const Details: FC<Props> = ({ prices, additionalPrices, className }) => {
	const { t } = useTranslation('Refund');
	const { Details: css } = useTheme('Entities').Order.ExchangeRefundPriceDetails;

	const isRetentionNotEmpty = prices.priceDetails.retention?.elements?.length > 0;

	const showAdditionalPrices = additionalPrices?.length > 0;

	return (
		<div className={cn(css.root, className)}>
			<ElementsPriceDetails elements={prices.priceDetails.refunded} />

			{showAdditionalPrices &&
				additionalPrices?.map(price => <PriceItem key={price.name} name={price.name} price={price.price} />)}

			<PriceItem
				name={t('Total has been paid')}
				className={css.priceHeadTitle}
				price={prices.priceDetails.paid.sum}
				delimiter="line"
			/>

			{isRetentionNotEmpty && (
				<>
					<div className={css.priceHeadTitle}>{t('Retentions')}</div>
					<ElementsPriceDetails elements={prices.priceDetails.retention} />
				</>
			)}

			{prices.priceDetails.retention?.sum && (
				<PriceItem
					name={t('Non refundable sum')}
					className={css.priceHeadTitle}
					price={prices.priceDetails.retention.sum}
					delimiter="line"
				/>
			)}

			<TotalRefund className={css.totalRefund} price={prices.priceToPay} />
		</div>
	);
};

export default Details;
